import { styled } from '@mui/material/styles'

type Props = {
  disabled?: boolean
}

export const ClosingReqLink = styled('span', {
  name: 'ClosingReqLink',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
  shouldForwardProp: (prop) => prop !== 'disabled',
})<Props>(({ theme, disabled }) => {
  const color = disabled ? theme.palette.text.disabled : '#01579b'

  return {
    color,
    fontSize: '13px',
    lineHeight: '143%',
    cursor: disabled ? 'default' : 'pointer',
  }
})
